<template>
    <div class='SavedProduct'>
        <a href='' @click.prevent='displayItem'>
            <span>{{myProduct.productSku}}</span>
        </a>
        <a href='' @click.prevent='removeItem'>
            <span>x</span>
        </a>
    </div>
</template>

<script>
    export default {
        name:'SavedProducts',
        props:['product'],
        data(){
            return {
                myProduct: this.$props.product
            }
        },
        methods:{
            displayItem(e){
                console.log('clicked');
                this.$store.dispatch('ItemCard/fetchSavedItem', {sku: this.myProduct.productSku, store: 'ItemCard'})
                    .then(() => {
                        console.log('returned?');
                        //this.saveProduct()
                        })
                    .catch((error) => {
                    //commit('setFetchError', error)
                        console.log('error returning promise: ' + error)
                    });
            },
            removeItem(e){
                console.log('close: '+ this.myProduct.productSku);
                this.$store.dispatch('ProductCollection/removeItem', this.myProduct.productSku);
            }
        }
    }
</script>